export default __webpack_public_path__ + "static/media/UniLogo.7897d45f.svg";